import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { DocumentModel } from './../../shared/models/simple-types/document.model';
import { DocumentService } from './../../shared/services/simple/document.service';

import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, combineLatest, concat, forkJoin, merge, Observable, of, Subscription } from 'rxjs';
import { map, switchMap, tap, filter, debounce, debounceTime, combineAll, first } from 'rxjs/operators';
import { CondReglModel } from 'src/app/shared/models/simple-types/cond-regl.model';
import { ModeReglModel } from 'src/app/shared/models/simple-types/modeRegl.model';
import { BcLineService } from 'src/app/shared/services/bc/bc-line.service';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { CondReglService } from 'src/app/shared/services/simple/cond-regl.service';
import { ModeReglService } from 'src/app/shared/services/simple/mode-regl.service';
import { ModalInfoOkComponent } from '../../shared/components/modals/info-ok/modal-info-ok.component';
import { BCLINEVALIDATORS, BCVALIDATORS, FormInfo } from '../../shared/constants/bc-validators';
import { TvaModel } from '../../shared/models/simple-types/tva.model';
import { SocieteModel } from '../../shared/models/simple-types/societe.model';
import { TvaService } from '../../shared/services/simple/tva.service';
import { ArticleService } from '../../shared/services/societe-linked/article.service';
import { StateService } from '../../shared/services/state.service';
import { BcValidationModel } from '../../shared/dtos/bcValidationModel';
import { SiteModel } from 'src/app/shared/models/societe-linked/site.model';
import { Ca1Model } from 'src/app/shared/models/societe-linked/ca1.model';
import { FournisseurModel } from 'src/app/shared/models/societe-linked/fournisseur.model';
import { ArticleModel } from 'src/app/shared/models/societe-linked/article.model';
import { CgChargeModel } from 'src/app/shared/models/simple-types/cg-charge.model';
import { Ca2Model } from 'src/app/shared/models/societe-linked/ca2.model';
import { CompModel } from 'src/app/shared/models/societe-linked/comp.model';
import { NaModel } from 'src/app/shared/models/simple-types/na.model';
import { BcLineModel } from 'src/app/shared/models/societe-linked/bc/bc-line.model';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { SiteService } from 'src/app/shared/services/societe-linked/site.service';
import { CgChargeService } from 'src/app/shared/services/simple/cg-charge.service';
import { Ca1Service } from 'src/app/shared/services/societe-linked/ca1.service';
import { FournisseurService } from 'src/app/shared/services/societe-linked/fournisseur.service';
import { CompService } from 'src/app/shared/services/societe-linked/comp.service';
import { Ca2Service } from 'src/app/shared/services/societe-linked/ca2.service';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { AddCommentModalComponent } from 'src/app/shared/components/modals/add-comment/add-comment-modal.component';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';
import { CategorieService } from 'src/app/shared/services/simple/categorie.service';
import { FamilleModel } from 'src/app/shared/models/simple-types/famille.model';
import { SsFamilleModel } from 'src/app/shared/models/simple-types/ss-famille.model';
import { FamilleService } from 'src/app/shared/services/simple/famille.service';
import { SsFamilleService } from 'src/app/shared/services/simple/ss-famille.service';
import { DestinationService } from 'src/app/shared/services/simple/destination.service';
import { getDestByString, NTHDestination } from 'src/app/shared/constants/flag';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

export class DetailBcinfos {
  sites: SiteModel[] = [];
  ca1s: Ca1Model[] = [];
  fournisseurs: FournisseurModel[] = [];
  condRegls: CondReglModel[] = [];
  modeRegls: ModeReglModel[] = [];
}

export class DetailBcLineinfos {
  destinations: NTHDestination[];
  categories: CategorieModel[] = [];
  articles: ArticleModel[] = [];
  cgCharges: CgChargeModel[] = [];
  ca1s: Ca1Model[] = [];
  ca2s: Ca2Model[] = [];
  comps: CompModel[] = [];
  nas: NaModel[] = [];
  tvas: TvaModel[] = [];
  familles: FamilleModel[] = [];
  ssFamilles: SsFamilleModel[] = [];
}

@Injectable()
export class BcComponentsService {

  society: SocieteModel;
  user: string;
  private detailBcInfosSource = new BehaviorSubject<DetailBcinfos>(null);
  private detailBcLineInfosSource: BehaviorSubject<DetailBcLineinfos>[] = [];
  private subscriptions: Subscription[] = [];
  private defaultDetailBcLineInfosSource: BehaviorSubject<DetailBcLineinfos> = new BehaviorSubject(new DetailBcLineinfos());
  detailBcInfos = this.detailBcInfosSource.asObservable();
  private defaultDetailBcLineInfos = this.defaultDetailBcLineInfosSource.asObservable();
  amountHorsTaxe = 0;
  private idCa1:  number;
  amountTtc = 0;
  site: string;
  infos = new DetailBcLineinfos();
  categoriesDefault =  [];
  ssFamilleDefault = [];
  changeValue = true;
  lastFournisseurCode = '';

  constructor(
    public dialog: MatDialog,
    protected router: Router,
    protected toastr: ToastrService,
    protected bcService: BcService,
    protected bcLineService: BcLineService,
    protected siteService: SiteService,
    protected cgChargeService: CgChargeService,
    protected ca1Service: Ca1Service,
    protected fournisseurService: FournisseurService,
    protected modeReglService: ModeReglService,
    protected condReglService: CondReglService,
    protected compService: CompService,
    private articleService: ArticleService,
    private documentService: DocumentService,
    private ca2Service: Ca2Service,
    private naService: NaService,
    private tvaService: TvaService,
    private  destinationService: DestinationService,
    private state: StateService,
    private familleService: FamilleService,
    private ssFamilleService: SsFamilleService,
    private categorieService: CategorieService) {
    
      this.subscriptions.push(this.state.user.subscribe(result => {
      this.user = result;
    }));
  }
  
  getBcLineRef(i: number): Observable<DetailBcLineinfos> {
    let bcLineInfo: BehaviorSubject<DetailBcLineinfos> = this.detailBcLineInfosSource[i];
    if (!bcLineInfo) {
      bcLineInfo = this.loadDetailBcLineFromDefault();
      this.detailBcLineInfosSource.push(bcLineInfo);
    }
    return bcLineInfo;
  }

  loadCa2(i: number, codeCa1: string, codeNa: string): void {
    const detail = this.detailBcLineInfosSource[i].value;
    const na = this.detailBcLineInfosSource[i].value.nas.find(obj => obj.code === codeNa);
    if (na && na.analyt2) {
      this.subscriptions.push(this.state.society.subscribe(soc => {
        this.subscriptions.push(this.ca2Service.getFromNaCa1(soc.id,  codeNa, codeCa1, 'BC').subscribe(ca2s => {
          detail.ca2s = ca2s;
          if (this.detailBcLineInfosSource && this.detailBcLineInfosSource[i])
            this.detailBcLineInfosSource[i].next(detail);
          if(ca2s.length === 0){
            this.toastr.warning('Le ca2 est obligatoire pour cette nature analytique', 'Veuillez configurer des ca2s');
          }
        }));
      }));
    }
    
  }

  loadDestination(i: number, bcLineForm: UntypedFormGroup): void{
    this.subscriptions.push(this.destinationService.getDestinationsFromActiviteAndCa1(bcLineForm.controls.idSociete.value, bcLineForm.controls.codeCa1.value)
    .subscribe(dest => {
        if (dest && this.detailBcLineInfosSource[i]) {
          this.detailBcLineInfosSource[i].value.destinations = dest;
          this.detailBcLineInfosSource[i].next(this.detailBcLineInfosSource[i].value);
          dest.length > 0 ? bcLineForm.get('destination').patchValue(dest.find(d => d === bcLineForm.get('destination').value)) : bcLineForm.get('destination').patchValue(null);
        } else if (dest) {
          dest.length > 0 ? bcLineForm.get('destination').patchValue(dest.find(d => d === bcLineForm.get('destination').value)) : bcLineForm.get('destination').patchValue(null);
        }
      }));
  }

  setLibelleCategorie(bcLineForm: UntypedFormGroup): void {
    this.subscriptions.push(this.state.society.subscribe(soc => {
      if (soc && bcLineForm.get('codeCategorie')) {
        this.subscriptions.push(this.categorieService.GetFromCodeSociete(bcLineForm.get('codeCategorie').value, soc.id).subscribe(cat => {
          if (cat) {
            bcLineForm.get('libelleCategorie').setValue(cat.libelle);
            bcLineForm.get('codeCategorie').patchValue(cat.code);
          } else {
            bcLineForm.get('libelleCategorie').setValue(null);
            bcLineForm.get('codeCategorie').patchValue(null);
          }
        }));
      } else {
        bcLineForm.get('libelleCategorie').setValue(null);
        bcLineForm.get('codeCategorie').patchValue(null);
      }
    }));
  }

  loadComp(i: number, codeNa: string, libelleNa: string): void {
    const detail = this.detailBcLineInfosSource[i].value;
    const na = this.detailBcLineInfosSource[i].value.nas.find(obj => obj.code === codeNa && obj.libelle === libelleNa);
    if (na && na.typeComp) {
      this.subscriptions.push(this.state.society.subscribe(soc => {
        this.subscriptions.push(this.compService.getFromNaAndSociete(soc.id, na.id).subscribe(comps => {
          if(comps.length > 0){
            detail.comps = comps;
            this.detailBcLineInfosSource[i].next(detail);
          }else{
            this.toastr.warning('Le complément est obligatoire pour cette nature analytique', 'Veuillez configurer des compléments');
          }
          
        }));
      }));
    }
  }

  loadDetailBc(): Observable<DetailBcinfos> {
    const infos = new DetailBcinfos();
    this.detailBcInfosSource.next(infos);
    this.subscriptions.push(
      this.state.society.pipe(filter(d => d !== null), debounceTime(300), switchMap(soc => {
      return forkJoin<any>([
          this.siteService.getFromSociete(soc.id).pipe(tap(objs => infos.sites = objs)),
          this.fournisseurService.getAllActive(soc.id).pipe(tap(objs => infos.fournisseurs = objs)),
          this.condReglService.getAll().pipe(tap(objs => infos.condRegls = objs)),
          this.modeReglService.getAll().pipe(tap(objs => infos.modeRegls = objs))
        ]);
      })).subscribe(_ => {
        this.detailBcInfosSource.next(infos);
      })
    );
    return this.detailBcInfos;
  }

  loadDetailBcLineFromDefault(): BehaviorSubject<DetailBcLineinfos> {
    const infos = new BehaviorSubject<DetailBcLineinfos>(new DetailBcLineinfos());
    this.subscriptions.push(this.defaultDetailBcLineInfosSource.subscribe(infoSource => {
      infos.next(JSON.parse(JSON.stringify(infoSource)));
    }));
    return infos;
  }

  loadDefaultDetailBcLine(): void {
    this.defaultDetailBcLineInfosSource.next(new DetailBcLineinfos());
    this.subscriptions.push(this.state.society.pipe(filter(d => d !== null), debounceTime(300), switchMap(soc => {
      return forkJoin<any>([
        // Comp à charger lors de la saisie du NA
        this.cgChargeService.getAll().pipe(tap(objs => {
          const detail = this.defaultDetailBcLineInfosSource.value;
          detail.cgCharges = objs;
          this.defaultDetailBcLineInfosSource.next(detail);
          return null;
        })),
        this.tvaService.getAll().pipe(tap(objs => {
          const detail = this.defaultDetailBcLineInfosSource.value;
          detail.tvas = objs;
          this.defaultDetailBcLineInfosSource.next(detail);
          return null;
        })),
      ]);
    })).subscribe(_ => {
    }));
    this.subscriptions.push(this.defaultDetailBcLineInfosSource.subscribe(res => {
    }));
  }

  // set validators max + min + event 
  calculSeuil(bcLine: BcLineModel, livraison: UntypedFormGroup){
    var min = bcLine.qteLivre * -1;
    var max = (bcLine.qte - bcLine.qteLivre);
    var tolerance = 0;
    let observable: Observable<any>;
    if (bcLine.codeCategorie !== '' && bcLine.codeCategorie !== undefined && bcLine.codeCategorie !== null) {
      observable = this.categorieService.GetFromCodeSociete(bcLine.codeCategorie, bcLine.idSociete)
      .pipe(switchMap((categorie) => {
        if (categorie){
          tolerance = (categorie.seuil * bcLine.qte) / 100;
          max = (bcLine.qte - bcLine.qteLivre) + tolerance;
          livraison.controls.qteLivre.setValidators([Validators.min(min), Validators.max(max)]);
        } else {
          livraison.controls.qteLivre.setValidators([Validators.min(min), Validators.max(max)]);
        }
        return livraison.get('qteLivre').valueChanges;
      }));
    } else {
      observable = livraison.get('qteLivre').valueChanges
    }
    observable.subscribe(x => {
      if(!livraison.get('id').value){
        if (x > max){
          this.toastr.warning("Livraison de la ligne BC N° " + bcLine.code + " : Qte en livraison " + livraison.get('qteLivre').value + " + la quantité déja livrée : " + bcLine.qteLivre + " est supérieur à la quantité commandée : " + bcLine.qte + " + la tolérence : " + tolerance)
          livraison.get('qteLivre').setValue(max);
        } else if (x < min) {
         this.toastr.warning("Livraison de la ligne BC N° " + bcLine.code + " : Qte en livraison " + livraison.get('qteLivre').value + " est inférieur à la quantité déja livrée : " + bcLine.qteLivre)
         livraison.get('qteLivre').setValue(min);
        } else {
          livraison.get('htLivre').setValue(bcLine.pu * x);
        }
      }
    });  
  }

  private createBcLineForm(bcLine: BcLineModel, bcLineValidators: Map<string, FormInfo>, i: number): UntypedFormGroup {
    const form = new UntypedFormGroup({});
    for (const [key, _] of bcLineValidators.entries()) {
      const control =
        new UntypedFormControl({ value: bcLine[key], disabled: bcLineValidators.get(key).disabled }, bcLineValidators.get(key).validators);
        form.addControl(key, control);
    }
    
    const livraisons = new UntypedFormArray([]);
    if (bcLine.livraisonsBc.length > 0) { // Pour chaque ligne
      for (const liv of bcLine.livraisonsBc) { // Pour chaque livraison de cette ligne
        const hasId = liv.id !== undefined; // On détermine si c'est une nouvelle ligne
        const disabledLitige = liv.qteLivre < 0 || bcLine.bAnnule || liv.qteLivre === undefined;
        const livraison = new UntypedFormGroup({}); // On crée un formGroup qui contiendra les contrôles nécessaires

        if (hasId || bcLine.qteRestant !== 0) //S’il y a une livraison ou qu’on peut livrer
        {
          livraison.addControl('id',
            new UntypedFormControl(
              { value: liv.id, disabled: true }
            )
          );
          livraison.addControl('idBcLigne',
            new UntypedFormControl(
              { value: liv.idBcLigne, disabled: true }
            )
          );
          livraison.addControl('idCreateur',
            new UntypedFormControl(
              { value: liv.idCreateur, disabled: true }
            )
          );
          livraison.addControl('dCreation',
            new UntypedFormControl(
              { value: liv.dCreation, disabled: true }
            )
          );
          livraison.addControl('idModifieur',
            new UntypedFormControl(
              { value: liv.idModifieur, disabled: true }
            )
          );
          livraison.addControl('dModification',
            new UntypedFormControl(
              { value: liv.dModification, disabled: true }
            )
          );
          livraison.addControl('dProvis',
            new UntypedFormControl(
              { value: liv.dProvis, disabled: true }
            )
          );
          livraison.addControl('qteLivre',
            new UntypedFormControl(
              { value: liv.qteLivre, disabled: hasId },
              []
            )
          );
          livraison.addControl('dLivraison',
            new UntypedFormControl(
              { value: liv.dLivraison, disabled: true },
              [Validators.required]
            )
          );
          livraison.addControl('htLivre',
            new UntypedFormControl(
              { value: liv.qteLivre * bcLine.pu, disabled: true }
            )
          );
          livraison.addControl('bProvis',
            new UntypedFormControl(
              { value: liv.bProvis, disabled: true }
            )
          );
          livraison.addControl('qteLitige',
            new UntypedFormControl(
              {
                value: liv.qteLitige, disabled: disabledLitige
              }, [Validators.min(0)]));
          livraisons.push(livraison);
          this.calculSeuil(bcLine, livraison);
        }
      }
    }

    form.addControl('livraisonsBc', livraisons);
    return form;
  }

  public getBcLineForm(bcLine: BcLineModel, bcLineValidators: Map<string, FormInfo>, i: number,  type?: DefinitionTypeBC): UntypedFormGroup {
    const form = this.createBcLineForm(bcLine, bcLineValidators, i);
    this.getBcLineRef(i);
    this.getBcLineFormEvent(form, i, type);
    return form;
  }

  public getBcLineFormEdit(bcLine: BcLineModel, bcLineValidators: Map<string, FormInfo>, i: number): UntypedFormGroup {
    const form = this.createBcLineForm(bcLine, bcLineValidators, i);
    this.getBcLineFormEvent(form, i, form.get('type')?.value);
    return form;
  }

  getBcLineFormEvent(bcLineForm: UntypedFormGroup, i: number, type?: DefinitionTypeBC): void {
    this.subscriptions.push(bcLineForm.controls.libelleArticle.valueChanges.subscribe((d: string) => {
      if (d) {
        bcLineForm.get('libelle').setValue(d.slice(0, 30));
      }
    }));

    // Get destinations by current society and selected ca1 (idSociete and codeCa1)
    let oldCodeCa1forNa = bcLineForm.get('codeCa1').value;
    this.subscriptions.push(combineLatest([
      bcLineForm.get('codeCa1').valueChanges,
      bcLineForm.get('libelleCa1').valueChanges,
      this.detailBcLineInfosSource[i],
      this.state.society])
      .pipe(
        filter(([code, libelle, detailBcLineInfos, soc]) => detailBcLineInfos && soc && oldCodeCa1forNa !== code),
        tap(([code, libelle, detailBcLineInfos, soc]) => {
            oldCodeCa1forNa = code;
            return [code, libelle, detailBcLineInfos, soc];
        }),
        switchMap(([code, libelle, detailBcLineInfos, soc]) => {
          const na = this.detailBcLineInfosSource[i].value.nas.find(obj => obj.code === bcLineForm.get('codeNa').value);
          if (na && na.analyt2) {
            return this.ca2Service.getFromNaCa1(soc.id, na.code, code, 'BC');
          }else {
            return of(null);
          }
         
         
      }))
      .subscribe(ca2s => {
        if(ca2s){
          const detailBcLineInfo = this.detailBcLineInfosSource[i].value;
            detailBcLineInfo.ca2s = ca2s;
            this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            bcLineForm.get('codeCa2').setValue('');
            bcLineForm.get('libelleCa2').setValue(''); 
            bcLineForm.get('codeCa2').setValidators(Validators.required);
          if(ca2s.length === 0){
            this.toastr.warning('Le ca2 est obligatoire pour cette nature analytique', 'Veuillez configurer des ca2s');
          }
        }
        
      }));

    // Get destinations by current society and selected ca1 (idSociete and codeCa1)
    let oldCodeCa1forDestination = bcLineForm.get('codeCa1').value;
    this.subscriptions.push(combineLatest([
      bcLineForm.get('codeCa1').valueChanges,
      bcLineForm.get('libelleCa1').valueChanges,
      this.detailBcLineInfosSource[i],
      this.state.society])
      .pipe(
        filter(([code, libelle, detailBcLineInfos, soc]) => detailBcLineInfos && soc && oldCodeCa1forDestination !== code),
        tap(([code, libelle, detailBcLineInfos, soc]) => {
          oldCodeCa1forDestination = code;
            return [code, libelle, detailBcLineInfos, soc];
        }),
        switchMap(([code, libelle, detailBcLineInfos, soc]) => {
          return this.destinationService.getDestinationsFromActiviteAndCa1(soc.id, bcLineForm.get('codeCa1').value);
         
      }))
      .subscribe(destinations => {
        if (this.detailBcLineInfosSource[i] && this.defaultDetailBcLineInfosSource) {
          var detailBcLineInfo = null;
          if (!type || type !== DefinitionTypeBC.BCEnveloppe) {
            detailBcLineInfo = this.detailBcLineInfosSource[i].value;
          } else {
            detailBcLineInfo = this.defaultDetailBcLineInfosSource.value;
          }
          detailBcLineInfo.destinations = destinations;
          this.detailBcLineInfosSource[i].next(detailBcLineInfo);
          if (destinations.length <= 0){
            bcLineForm.get('destination').setValue(null);
          }else{
            // updateValueAndValidity afin de reloader les données
            bcLineForm.get('destination').updateValueAndValidity({ emitEvent: true });
          }
        }       
      }));

    // autoLoad  Famille / Sous Famille / Catégorie From Activite when Destination
    let oldDestination = null;
    let oldCa1 = bcLineForm.get('codeCa1').value;
    this.subscriptions.push(combineLatest([
      bcLineForm.get('destination').valueChanges,
      this.detailBcLineInfosSource[i],
      this.state.society
    ]).pipe(
      tap (([destination, detail, soc]) => {
        if (oldDestination !== null && oldDestination !== destination) {
          bcLineForm.get('codeFamille').setValue('');
          bcLineForm.get('libelleFamille').setValue('');
          bcLineForm.get('codeSsFamille').setValue('');
          bcLineForm.get('libelleSsFamille').setValue('');
          bcLineForm.get('codeCategorie').setValue('');
          bcLineForm.get('libelleCategorie').setValue('');
        }
      }),
        filter(([destination, detail, soc]) => {
          return detail !== null && soc && (oldDestination !== destination || oldCa1 !== bcLineForm.get('codeCa1').value);
        }),
        tap(([destination, detail, soc]) => {
          oldDestination = destination;
          oldCa1 = bcLineForm.get('codeCa1').value;
          if (!destination && destination !== 0 && oldDestination) {
            oldDestination = null;
            bcLineForm.get('codeFamille').setValue('');
            bcLineForm.get('libelleFamille').setValue('');
            bcLineForm.get('codeSsFamille').setValue('');
            bcLineForm.get('libelleSsFamille').setValue('');
            bcLineForm.get('codeCategorie').setValue('');
            bcLineForm.get('libelleCategorie').setValue('');
            const detailBcLineInfo = this.detailBcLineInfosSource[i].value;
            if (detailBcLineInfo && detailBcLineInfo.familles && detailBcLineInfo.familles.length > 0) {
              detailBcLineInfo.familles = [];
              this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            }
            if (detailBcLineInfo && detailBcLineInfo.ssFamilles && detailBcLineInfo.ssFamilles.length > 0) {
              detailBcLineInfo.ssFamilles = [];
              this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            }
            if (detailBcLineInfo && detailBcLineInfo.categories && detailBcLineInfo.categories.length > 0) {
              detailBcLineInfo.categories = [];
              this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            }
          }
          if (!destination && destination !== 0) {
            bcLineForm.get('codeFamille').setValidators([]);
            bcLineForm.get('codeFamille').disable();
            bcLineForm.get('codeFamille').setValue('');
            bcLineForm.get('libelleFamille').setValue('');
            bcLineForm.get('codeSsFamille').setValidators([]);
            bcLineForm.get('codeSsFamille').disable();
            bcLineForm.get('codeSsFamille').setValue('');
            bcLineForm.get('libelleSsFamille').setValue('');
            bcLineForm.get('codeCategorie').setValidators([]);
            bcLineForm.get('codeCategorie').disable();
            bcLineForm.get('codeCategorie').setValue('');
            bcLineForm.get('libelleCategorie').setValue('');
          }
          return [destination, detail, soc];
        }),
        filter(([destination, detail, soc]) => {
          return destination || destination === 0;
        }),
        switchMap(([destination, detail, soc]) => {
          oldDestination = destination;
          if (soc.activite && type && type === DefinitionTypeBC.BCEnveloppe) {
            return this.destinationService.getCategoriesForDestinationEnveloppe(soc.id, bcLineForm.get('codeCa1').value, destination);
          } else if (soc.activite) {
            return this.destinationService.getCategoriesForDestination(soc.id, bcLineForm.get('codeCa1').value, destination);
          } else {
            return of([]);
          }
        }))
      .subscribe( (categories:CategorieModel[]) => {
        let ssFamilles = Array.from(new Set(categories.map(x=>x.ssFamille).map(obj => obj.id))).map(id => {
          return categories.map(x=>x.ssFamille).find(obj => obj.id === id);
        });
        let familles = Array.from(new Set(ssFamilles.map(x=>x.famille).map(obj => obj.id))).map(id => {
          return ssFamilles.map(x=>x.famille).find(obj => obj.id === id);
        });
        const detail = this.detailBcLineInfosSource[i].value;
        detail.familles = familles
        if (detail.familles.length > 0) {
          if (!bcLineForm.controls.destination.disabled){
            bcLineForm.get('codeFamille').setValidators(Validators.required);
            bcLineForm.get('codeFamille').enable();
          }
        } else {
          bcLineForm.get('codeFamille').setValidators([]);
          bcLineForm.get('codeFamille').disable();
          bcLineForm.get('codeFamille').setValue('');
          bcLineForm.get('libelleFamille').setValue('');

        }
        detail.ssFamilles = ssFamilles;
        this.ssFamilleDefault = ssFamilles;
        if (detail.ssFamilles.length > 0) {
          if (!bcLineForm.controls.destination.disabled){
            bcLineForm.get('codeSsFamille').setValidators(Validators.required);
            bcLineForm.get('codeSsFamille').enable();
          }
        } else {
          bcLineForm.get('codeSsFamille').setValidators([]);
          bcLineForm.get('codeSsFamille').disable();
          bcLineForm.get('codeSsFamille').setValue('');
          bcLineForm.get('libelleFamille').setValue('');
        }
        this.categoriesDefault = categories;
        detail.categories = categories;
        if (categories.length > 0) {
          if (!bcLineForm.controls.destination.disabled){
            bcLineForm.get('codeCategorie').setValidators(Validators.required);
            bcLineForm.get('codeCategorie').enable();
          }
        } else {
          bcLineForm.get('codeCategorie').setValidators([]);
          bcLineForm.get('codeCategorie').disable();
          bcLineForm.get('codeCategorie').setValue('');
          bcLineForm.get('libelleCategorie').setValue('');
        }
        this.detailBcLineInfosSource[i].next(detail);
      }));

    // autoLoad  Sous Famille / Catégorie when Famille
    let oldFamilleCode = '';
    this.subscriptions.push(combineLatest([
      bcLineForm.get('codeFamille').valueChanges,
      bcLineForm.get('libelleFamille').valueChanges,
      this.detailBcLineInfosSource[i]])
      .pipe(
        filter(([code, libelle, detail]) => detail !== null && code !== oldFamilleCode),
        tap(([code, libelle, detail]) => {
          if (code === null || code === '') {
            bcLineForm.get('codeSsFamille').setValue('');
            bcLineForm.get('libelleSsFamille').setValue('');
            oldFamilleCode = '';
            detail.ssFamilles = this.ssFamilleDefault;
            detail.categories = this.categoriesDefault;
            return [code, libelle, detail];
          }
        }),
        filter(([code, libelle, detail]) => {
          return code
        }))
      .subscribe(([code, libelle, detail]) => {
        if (oldFamilleCode !== '' && this.changeValue){
          bcLineForm.get('codeSsFamille').setValue('');
          bcLineForm.get('libelleSsFamille').setValue('');
        }else {
          this.changeValue = true;
        }
        oldFamilleCode = code;

        if (detail.familles.length > 0) {
          const familleSelected = detail.familles.find(f => f.code === code);
          if (familleSelected) {
            detail.ssFamilles = this.ssFamilleDefault;
            detail.ssFamilles = this.ssFamilleDefault.slice().filter(c => c.idFamille == familleSelected.id);
            if (bcLineForm.get('codeSsFamille').value === ""){
              detail.categories = [];
              for (var sf of detail.ssFamilles){
                var filtre = this.categoriesDefault.slice().filter(c => c.idSsFamille == sf.id);
                detail.categories = detail.categories.concat(filtre);
              }
            }
          }
        }
        this.detailBcLineInfosSource[i].next(detail);
      }));

    // autoLoad  Catégorie when Sous Famille 
    let oldSsFamilleCode = bcLineForm.get('codeSsFamille').value;
    this.subscriptions.push(combineLatest([
      bcLineForm.get('codeSsFamille').valueChanges,
      bcLineForm.get('libelleSsFamille').valueChanges,
      this.detailBcLineInfosSource[i]])
      .pipe(
        filter(([code, libelle, detail]) => detail !== null && code !== oldSsFamilleCode),
        tap(([code, libelle, detail]) => {
          if (code === null || code === '') {
            bcLineForm.get('codeCategorie').setValue('');
            bcLineForm.get('libelleCategorie').setValue('');
            oldSsFamilleCode = '';
            detail.categories = [];
            for (var sf of detail.ssFamilles){
              var filtre = this.categoriesDefault.slice().filter(c => c.idSsFamille == sf.id);
              detail.categories = detail.categories.concat(filtre);
            }
            return [code, libelle, detail];
          }
        }),
        filter(([code, libelle, detail]) => {
          return code
        }))
      .subscribe(([code, libelle, detail]) => {
        oldSsFamilleCode = code;
        if (detail.ssFamilles.length > 0) {
          const ssfamilleSelected = detail.ssFamilles.find(f => f.code === code);
          if (ssfamilleSelected && detail.ssFamilles.length > 0) {
            detail.categories = this.categoriesDefault.slice().filter(c => c.idSsFamille == ssfamilleSelected.id);
            bcLineForm.get('codeFamille').setValue(ssfamilleSelected.famille.code);
            bcLineForm.get('libelleFamille').setValue(ssfamilleSelected.famille.libelle);
            this.changeValue = false;
          }
        }
        this.detailBcLineInfosSource[i].next(detail);
      }));

       // autoLoad  from NA
    let oldNaCode = '';
    this.subscriptions.push(combineLatest([
      bcLineForm.get('codeNa').valueChanges,
      bcLineForm.get('libelleNa').valueChanges,
      this.detailBcLineInfosSource[i],
      this.state.society
    ]).pipe(
        filter(([code, libelle, detail, soc]) => {
          return detail !== null && soc && oldNaCode !== code + libelle;
        }),
        tap(([code, libelle, detail, soc]) => {
          if (!code && !libelle) {
            oldNaCode = code + libelle;
            bcLineForm.get('codeComp').setValue('');
            bcLineForm.get('libelleComp').setValue('');
            bcLineForm.get('codeCa2').setValue('');
            bcLineForm.get('libelleCa2').setValue('');
            const detailBcLineInfo = this.detailBcLineInfosSource[i].value;
            oldNaCode = '';
            if (detailBcLineInfo && detailBcLineInfo.comps && detailBcLineInfo.comps.length > 0) {
              detailBcLineInfo.comps = [];
              this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            }
            if (detailBcLineInfo && detailBcLineInfo.ca2s && detailBcLineInfo.ca2s.length > 0) {
              detailBcLineInfo.ca2s = [];
              this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            }
          }
          return [code, libelle, detail, soc];
        }),
        filter(([code, libelle, detail, soc]) => {
          const na = this.detailBcLineInfosSource[i].value.nas.find(obj => obj.code === code && obj.libelle === libelle);
          return na && code && libelle;
        }),
        switchMap(([code, libelle, detail, soc]) => {
          oldNaCode = code + libelle;
          const na = this.detailBcLineInfosSource[i].value.nas.find(obj => obj.code === code && obj.libelle === libelle);
          if (na.typeComp && na.analyt2) {
            return combineLatest([this.compService.getFromNaAndSociete(soc.id, na.id), this.ca2Service.getFromNaCa1(soc.id,  code, bcLineForm.get('codeCa1').value,'BC')]);
          } else if (na.typeComp && !na.analyt2) {
            return combineLatest([this.compService.getFromNaAndSociete(soc.id, na.id), of(null)]);
          } else if (!na.typeComp && na.analyt2) {
            return combineLatest([of(null), this.ca2Service.getFromNaCa1(soc.id,  code, bcLineForm.get('codeCa1').value,'BC')]);
          } else if (!na.typeComp && !na.analyt2) {
            return combineLatest([of(null), of(null)]);
          }
      })).subscribe(([comps, ca2s]) => {
        const detail = this.detailBcLineInfosSource[i].value;
        if (comps && type !== DefinitionTypeBC.BCEnveloppe) {
          detail.comps = comps;
          bcLineForm.get('codeComp').setValidators(Validators.required);
          bcLineForm.get('codeComp').enable();
          if(comps.length === 0){
            this.toastr.warning('Le complément est obligatoire pour cette nature analytique', 'Veuillez configurer des compléments');
          }
        } else {
          detail.comps = [];
          bcLineForm.get('codeComp').setValidators([]);
          bcLineForm.get('codeComp').disable();
          bcLineForm.get('codeComp').setValue('');
          bcLineForm.get('libelleComp').setValue('');
        }
        
        if (ca2s && type !== DefinitionTypeBC.BCEnveloppe) {
          detail.ca2s = ca2s;
          bcLineForm.get('codeCa2').setValidators(Validators.required);
          bcLineForm.get('codeCa2').enable();
          if (ca2s.length === 0){
            this.toastr.warning('Le ca2 est obligatoire pour cette nature analytique', 'Veuillez configurer des ca2s');
          }
        } else {
          detail.ca2s = [];
          bcLineForm.get('codeCa2').setValidators([]);
          bcLineForm.get('codeCa2').disable();
          bcLineForm.get('codeCa2').setValue('');
          bcLineForm.get('libelleCa2').setValue('');
        }
        this.detailBcLineInfosSource[i].next(detail);
      }));

    // autoSet cgCharge when Na selected
    let oldNaCodeToCgCharge = null;
    this.subscriptions.push(combineLatest([
      bcLineForm.get('codeNa').valueChanges,
      bcLineForm.get('libelleNa').valueChanges,
      this.detailBcLineInfosSource[i]])
      .pipe(
        filter(([code, libelle, detail]) => detail !== null && code !== oldNaCodeToCgCharge),
        tap(([code, libelle, detail]) => {
          if (!code && !libelle) {
            bcLineForm.get('codeCgCharge').setValue('');
            bcLineForm.get('libelleCgCharge').setValue('');
            oldNaCodeToCgCharge = '';
            const detailBcLineInfo = this.detailBcLineInfosSource[i].value;
            if (detailBcLineInfo && detailBcLineInfo.cgCharges && detailBcLineInfo.cgCharges.length > 0) {
              this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            }
            return [code, libelle, detail];
          }
        }),
        filter(([code, libelle, detail]) => {
          const naSelected = detail.nas.find(na => na.code === code && na.libelle === libelle);
          return naSelected !== undefined && naSelected !== null;
        }))
      .subscribe(([code, libelle, detail]) => {
        oldNaCodeToCgCharge = code;
        if (detail.nas.length > 0) {
          const naSelected = detail.nas.find(na => na.code === code && na.libelle === libelle);
          if (naSelected && detail.cgCharges.length > 0) {
            const cgChargeAuto = detail.cgCharges.find(cg => cg.code === naSelected.cgCharge);
            if (cgChargeAuto) {
              bcLineForm.get('codeCgCharge').setValue(cgChargeAuto.code);
              bcLineForm.get('libelleCgCharge').setValue(cgChargeAuto.libelle);
            }else{
              bcLineForm.get('codeCgCharge').setValue('');
              bcLineForm.get('libelleCgCharge').setValue('');
            }
          }
        }
      }));

    // Calcul du montant HT pour l'enregistrement en base de données.
    if(!type || (type && type !== DefinitionTypeBC.BCEnveloppe)){
      this.subscriptions.push(combineLatest([bcLineForm.get('pu').valueChanges])
      .subscribe(([prixU]) => {
        if ((prixU || prixU === 0)) {
          this.amountHorsTaxe = parseFloat((prixU * bcLineForm.get('qte').value).toFixed(2));
          bcLineForm.get('ht').setValue(0);
          bcLineForm.get('ht').patchValue(this.amountHorsTaxe);
          if (bcLineForm.get('tauxTva').value >= 0) {
            const tva = this.defaultDetailBcLineInfosSource.value.tvas.find(t => t.code === bcLineForm.get('codeTva').value);
            if (tva) {
              const taux = tva.autoIntra ? 0 : tva.taux;
              this.amountTtc = this.amountHorsTaxe + ((this.amountHorsTaxe * taux) / 100);
              bcLineForm.get('ttc').setValue(0);
              bcLineForm.get('ttc').patchValue(this.amountTtc);
            }
          }
        }
      }));
    }
    

    // Calcul du montant HT pour l'enregistrement en base de données.
    if(!type || (type && type !== DefinitionTypeBC.BCEnveloppe)){
      this.subscriptions.push(combineLatest([bcLineForm.get('qte').valueChanges])
      .subscribe(([qt]) => {
        if (qt) {
          if (qt > 0) {
            this.amountHorsTaxe = parseFloat((qt * bcLineForm.get('pu').value).toFixed(2));
            bcLineForm.get('ht').setValue(0);
            bcLineForm.get('ht').patchValue(this.amountHorsTaxe);
          }
        }
      }));
    }
    // Calcul du montant HT pour l'enregistrement en base de données.
    this.subscriptions.push(combineLatest([bcLineForm.get('qteLivre').valueChanges, this.state.society])
    .pipe(
      filter(([qteLivre, soc]) => qteLivre !== null && soc !== null ),
      switchMap(([qteLivre, soc]) => {
        return this.categorieService.GetFromCodeSociete(bcLineForm.get('codeCategorie').value , soc.id);
      }))
      .subscribe((categorie) => {
        const today = new Date(Date.now());
        if (bcLineForm.get('qteLivre').value) {
          var tolerance = categorie ? (categorie.seuil * bcLineForm.get('qte').value / 100) : 0;  
          if (bcLineForm.get('qteLivre').value <= (bcLineForm.get('qte').value + tolerance) ) {
            if (new Date(bcLineForm.get('dLivraison').value) < today) {
              bcLineForm.get('dLivraison').setValue(today);
              bcLineForm.get('dLivraison').patchValue(today);
            }
          } else {
            bcLineForm.get('qteLivre').setValue(0);
            bcLineForm.get('qteLivre').patchValue(bcLineForm.get('qte').value);
          }
        }
      }));

    // Calcul du montant TTC pour l'enregistrement en base de données.
    this.subscriptions.push(combineLatest([bcLineForm.get('tauxTva').valueChanges, this.detailBcLineInfosSource[i]])
      .subscribe(([tauxTva, detail]) => {
        if (this.amountHorsTaxe && tauxTva && detail) {
          if (this.amountHorsTaxe > 0 && tauxTva >= 0) {
            const tva = detail.tvas.find(t => t.code === bcLineForm.get('codeTva').value);
            if (tva) {
              const taux = tva.autoIntra ? 0 : tva.taux;
              this.amountTtc = this.amountHorsTaxe + ((this.amountHorsTaxe * taux) / 100);
              bcLineForm.get('ttc').setValue(0);
              bcLineForm.get('ttc').patchValue(this.amountTtc);
            }
          }
        }
      }));

    this.subscriptions.push(combineLatest([bcLineForm.get('ht').valueChanges, this.detailBcLineInfosSource[i]])
      .subscribe(([ht, detail]) => {
        if (ht && detail) {
          if (this.amountHorsTaxe !== 0 && bcLineForm.get('ttc').value > 0) {
            const tva = detail.tvas.find(t => t.code === bcLineForm.get('codeTva').value);
            if (tva) {
              const taux = tva.autoIntra ? 0 : tva.taux;
              this.amountTtc = ht + ((ht * taux) / 100);
              bcLineForm.get('ttc').setValue(0);
              bcLineForm.get('ttc').patchValue(this.amountTtc);
            }
          }
        }
    }));
    let oldCategorie = '';
    this.subscriptions.push(combineLatest([
      bcLineForm.get('codeCategorie').valueChanges,
      this.detailBcLineInfosSource[i],
      this.state.society])
      .pipe(
        filter(([code, libelle, detail]) => {
          return detail !== null && oldCategorie !== code ;
        }),
        tap(([code, detailBcLineInfos, soc]) => {
          if (!code) {
            bcLineForm.get('codeNa').setValue('');
            bcLineForm.get('libelleNa').setValue('');
            oldCategorie = '';
            const detailBcLineInfo = this.detailBcLineInfosSource[i].value;
            if (detailBcLineInfo && detailBcLineInfo.nas && detailBcLineInfo.nas.length > 0) {
              this.detailBcLineInfosSource[i].next(detailBcLineInfo);
            }
            return [code, detailBcLineInfos, soc];
          }
        }),
        filter(([code, detailBcLineInfos, soc]) =>
        code && detailBcLineInfos && detailBcLineInfos.categories.length && soc != null && code !== oldCategorie),
      switchMap(([code, detailBcLineInfos, soc]) => {
        if (code && detailBcLineInfos && (bcLineForm.get('destination').value || bcLineForm.get('destination').value === 0 )) {
          const categorie = detailBcLineInfos.categories.find(categorieFind => categorieFind.code === code);
          if (categorie && code !== oldCategorie) {
            oldCategorie = code;
            if(!type || (type && type !== DefinitionTypeBC.BCEnveloppe)){
              if (categorie.codeTva && detailBcLineInfos.tvas.length !== 0) {
                const tva = detailBcLineInfos.tvas.find(tvaFind => tvaFind.code === categorie.codeTva);            
                if (tva){
                  if (!bcLineForm.get('id').value) {
                    bcLineForm.get('codeTva').setValue(tva.code);
                    bcLineForm.get('tauxTva').setValue(tva.taux);
                    bcLineForm.get('libelleTva').setValue(tva.libelle);
                  }
                }             
              }
            }else{
              const tva = detailBcLineInfos.tvas.find(tvaFind => tvaFind.code === "T0");            
                if (tva){
                  bcLineForm.get('codeTva').setValue(tva.code);
                  bcLineForm.get('tauxTva').setValue(tva.taux);
                  bcLineForm.get('libelleTva').setValue(tva.libelle);
                }       
            }
            
            if (categorie.ssFamille){
              bcLineForm.get('codeSsFamille').setValue(categorie.ssFamille.code);
              bcLineForm.get('libelleSsFamille').setValue(categorie.ssFamille.libelle);
              if (categorie.ssFamille.famille){
                bcLineForm.get('codeFamille').setValue(categorie.ssFamille.famille.code);
                bcLineForm.get('libelleFamille').setValue(categorie.ssFamille.famille.libelle);
              }
              this.changeValue = false;
            }
          }
          if (categorie) {
            return this.naService.getFromDestinationCategorie(soc.activite.id, categorie.id, bcLineForm.get('destination').value);
          } else {
            return of(null);
          }
        }
      }))
      .subscribe(na => {
        if (na) {
          const detailBcLineInfo = this.detailBcLineInfosSource[i].value;
          detailBcLineInfo.nas = [na];
          bcLineForm.get('codeNa').setValue(na.code);
          bcLineForm.get('libelleNa').setValue(na.libelle);
          bcLineForm.get('codeNa').disable();
          bcLineForm.get('libelleNa').disable();
          this.detailBcLineInfosSource[i].next(detailBcLineInfo);
        }
    }));
  }
  private getBcFormEvent(bcForm: UntypedFormGroup): void {

    // Get ca1s by current society and selected site (idSociete and codeSite)
    let oldCodeSiteToCa1s = '';
    this.subscriptions.push(combineLatest([
        bcForm.get('codeSite').valueChanges,
        bcForm.get('libelleSite').valueChanges,
        // TODO impact de la suprresion ?
        this.defaultDetailBcLineInfosSource,
        this.detailBcInfos,
        this.state.society])
      .pipe(filter(([code, libelle, detailBcLineInfos, detailBcInfos, soc]) => {
        return code && soc && libelle && detailBcLineInfos !== null && detailBcInfos !== null && oldCodeSiteToCa1s !== code;
      }),
        switchMap(([code, libelle, detailBcLineInfos, detailBcInfos, soc]) => {
          oldCodeSiteToCa1s = code;
          return this.ca1Service.getFromSite(soc.id, code);
        })
      )
      .subscribe(ca1s => {
        const detailsBcInfo = this.detailBcInfosSource.value;
        var detailBcLineInfo = null;
        var type = bcForm.get('type').value;
        if (!type || type !== DefinitionTypeBC.BCEnveloppe) {
          detailBcLineInfo = this.defaultDetailBcLineInfosSource.value;
        } else {
          detailBcLineInfo = this.detailBcLineInfosSource[this.detailBcLineInfosSource.length - 1].value;
        }
        detailsBcInfo.ca1s = ca1s;
        detailBcLineInfo.ca1s = ca1s;
        this.detailBcInfosSource.next(detailsBcInfo);
        this.defaultDetailBcLineInfosSource.next(detailBcLineInfo);
      }));

    // autoSet SiteLivraison when Site selected
    this.subscriptions.push(combineLatest([bcForm.get('codeSite').valueChanges, bcForm.get('libelleSite').valueChanges, this.detailBcInfos])
      .pipe(filter(([code, libelle, detail]) => code && libelle && detail !== null))
      .subscribe(([code, libelle, detail]) => {
        if (detail.sites && bcForm.get('codeSiteLivraison') && bcForm.get('libelleSiteLivraison')) {
          const siteSelected = detail.sites.find(site => site.code === code && site.libelle === libelle);
          if (siteSelected && !bcForm.get('codeSiteLivraison').value && !bcForm.get('libelleSiteLivraison').value) {
            bcForm.get('codeSiteLivraison').setValue(siteSelected.code);
            bcForm.get('libelleSiteLivraison').setValue(siteSelected.libelle);
          }
        }
      }));

    // autoSet Mode de regl and Cond de regl when Fournisseur selected
    this.subscriptions.push(combineLatest([bcForm.get('codeFourn').valueChanges, bcForm.get('libelleFourn').valueChanges, this.detailBcInfos])
      .pipe(filter(([code, libelle, detail]) => code && libelle && detail !== null))
      .subscribe(([code, libelle, detail]) => {
        let condOrModeChanged = false;

        this.lastFournisseurCode = !this.lastFournisseurCode ? code : this.lastFournisseurCode;
        if (detail.fournisseurs) {
          const fournisseurSelected = detail.fournisseurs.find(fourn => fourn.code === code && fourn.libelle === libelle);
          if (fournisseurSelected && fournisseurSelected.condRegl && (bcForm.get('codeCondRegl').value == ''  ||  (this.lastFournisseurCode !== code))) {
            const condRegl = detail.condRegls.find(cond => cond.code === fournisseurSelected.condRegl);
            bcForm.get('codeCondRegl').setValue(condRegl.code);
            bcForm.get('libelleCondRegl').setValue(condRegl.libelle);
            condOrModeChanged = true;
          }
        if (fournisseurSelected && fournisseurSelected.modeRegl && (bcForm.get('codeModeRegl').value == '' ||  (this.lastFournisseurCode !== code))) {
          const modeRegl = detail.modeRegls.find(mode => mode.code === fournisseurSelected.modeRegl);
          if (modeRegl) {
            bcForm.get('codeModeRegl').setValue(modeRegl.code);
            bcForm.get('libelleModeRegl').setValue(modeRegl.libelle);
            condOrModeChanged = true;
          }
        }
        this.lastFournisseurCode = condOrModeChanged ? code : this.lastFournisseurCode;
      }
    }));
  }

  // BcForm + DefaultBcLine
  public getBcForm(bc: BcModel, bcValidators: Map<string, FormInfo>, bcLineValidators: Map<string, FormInfo>): UntypedFormGroup {
    // Gen du BC
    const form = new UntypedFormGroup({});
    for (const [key, value] of bcValidators.entries()) {
      if (key !== 'bcLines' && key !== 'cycleBcs') {
        const control = new UntypedFormControl({ value: bc[key], disabled: bcValidators.get(key).disabled }, bcValidators.get(key).validators);
        form.addControl(key, control);
      }
    }
    const bcFormArray = new UntypedFormArray([]);
    this.loadDefaultDetailBcLine();
    if (bc.bcLines && bc.bcLines.length > 0) {
      let i = 0;
      for (const bcLine of bc.bcLines) {
        if (bcLine.bAnnule || bcLine.fLivre === 2) {
          bcFormArray.push(this.getBcLineForm(bcLine, BCLINEVALIDATORS.EDITION_ANNULE, i, bc.type));
        } else {
          bcFormArray.push(this.getBcLineForm(bcLine, bcLineValidators, i, bc.type));
        }
        i++;
      }
    }
    bcFormArray.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    form.addControl('bcLines', bcFormArray);
    return form;
  }

  public createBcLine(bcForm: UntypedFormGroup): UntypedFormGroup {
    const bcLine = new BcLineModel();
    const i = (bcForm.get('bcLines') as UntypedFormArray).length;
    bcLine.dLivraison = bcForm.get('dLivraison').value;
    const row = this.getBcLineForm(bcLine, BCLINEVALIDATORS.CREATE, i);
    // Initializing designation field when article is selected in table field autocomplete
    row.get('codeCa1').patchValue(bcForm.get('codeCa1').value);
    row.get('libelleCa1').patchValue(bcForm.get('libelleCa1').value);
    row.get('idSociete').patchValue(bcForm.get('idSociete').value);
    row.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    return row;
  }
  

  public createBcLineEnveloppe(bcForm: UntypedFormGroup): UntypedFormGroup {
    const bcLine = new BcLineModel();
    const i = (bcForm.get('bcLines') as UntypedFormArray).length;
    const row = this.getBcLineForm(bcLine, BCLINEVALIDATORS.BROUILLON_ENVELOPPE, i, DefinitionTypeBC.BCEnveloppe);
    // Initializing designation field when article is selected in table field autocomplete
    row.get('libelle').patchValue("Ligne enveloppe");
    row.get('codeCa1').patchValue(bcForm.get('codeCa1').value);
    row.get('libelleCa1').patchValue(bcForm.get('libelleCa1').value);
    row.get('idSociete').patchValue(bcForm.get('idSociete').value);
    row.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    return row;
  }

  cancelCreatedLine(): void {
    this.detailBcLineInfosSource.pop();
  }

  duplicateBcLineRow(bcLineForm: UntypedFormGroup): any {
    const i = this.detailBcLineInfosSource.length;
    let bcLineDuplicated = new BcLineModel();
    bcLineDuplicated = bcLineForm.value;
    bcLineDuplicated.idSociete = bcLineForm.controls.idSociete.value;
    bcLineDuplicated.destination = bcLineForm.get('destination').value;
    bcLineDuplicated.codeFamille = bcLineForm.get('codeFamille').value;
    bcLineDuplicated.libelleFamille = bcLineForm.get('libelleFamille').value;
    bcLineDuplicated.codeSsFamille = bcLineForm.get('codeSsFamille').value;
    bcLineDuplicated.libelleSsFamille = bcLineForm.get('libelleSsFamille').value;
    bcLineDuplicated.codeCa2 = bcLineForm.get('codeCategorie').value;
    bcLineDuplicated.codeNa = bcLineForm.get('codeNa').value;
    bcLineDuplicated.libelleNa = bcLineForm.get('libelleNa').value;
    bcLineDuplicated.codeCgCharge = bcLineForm.get('codeCgCharge').value;
    bcLineDuplicated.libelleCgCharge = bcLineForm.get('libelleCgCharge').value;
    bcLineDuplicated.codeCa2 = bcLineForm.get('codeCa2').value;
    bcLineDuplicated.libelleCa2 = bcLineForm.get('libelleCa2').value;
    bcLineDuplicated.codeComp = bcLineForm.get('codeComp').value;
    bcLineDuplicated.libelleComp = bcLineForm.get('libelleComp').value;
    bcLineDuplicated.tauxTva = bcLineForm.get('tauxTva').value;
    bcLineDuplicated.ht = bcLineForm.get('ht').value;
    bcLineDuplicated.ttc = bcLineForm.get('ttc').value;
    const row = this.getBcLineForm(bcLineDuplicated, BCLINEVALIDATORS.BROUILLON, i);
    return row;
  }

  duplicateBcLineEnveloppeRow(bcLineForm: UntypedFormGroup): any {
    const i = this.detailBcLineInfosSource.length;
    let bcLineDuplicated = new BcLineModel();
    bcLineDuplicated = bcLineForm.value;
    bcLineDuplicated.idSociete = bcLineForm.controls.idSociete.value;
    bcLineDuplicated.destination = bcLineForm.get('destination').value;
    bcLineDuplicated.codeFamille = bcLineForm.get('codeFamille').value;
    bcLineDuplicated.libelleFamille = bcLineForm.get('libelleFamille').value;
    bcLineDuplicated.codeSsFamille = bcLineForm.get('codeSsFamille').value;
    bcLineDuplicated.libelleSsFamille = bcLineForm.get('libelleSsFamille').value;
    bcLineDuplicated.codeCa2 = bcLineForm.get('codeCategorie').value;
    bcLineDuplicated.codeNa = bcLineForm.get('codeNa').value;
    bcLineDuplicated.libelleNa = bcLineForm.get('libelleNa').value;
    bcLineDuplicated.codeCgCharge = bcLineForm.get('codeCgCharge').value;
    bcLineDuplicated.libelleCgCharge = bcLineForm.get('libelleCgCharge').value;
    bcLineDuplicated.codeCa2 = bcLineForm.get('codeCa2').value;
    bcLineDuplicated.libelleCa2 = bcLineForm.get('libelleCa2').value;
    bcLineDuplicated.codeComp = bcLineForm.get('codeComp').value;
    bcLineDuplicated.libelleComp = bcLineForm.get('libelleComp').value;
    bcLineDuplicated.tauxTva = bcLineForm.get('tauxTva').value;
    bcLineDuplicated.ht = 0;
    bcLineDuplicated.ttc = bcLineForm.get('ttc').value;
    bcLineDuplicated.codeCa1 = bcLineForm.get('codeCa1').value;
    bcLineDuplicated.libelleCa1 = bcLineForm.get('libelleCa1').value;
    bcLineDuplicated.libelle = null;
    bcLineDuplicated.id = 0;
    bcLineDuplicated.code = '*'
    bcLineDuplicated.position = 0
    bcLineDuplicated.dLivraison = new Date();
    const row = this.getBcLineForm(bcLineDuplicated, BCLINEVALIDATORS.BROUILLON_ENVELOPPE, i);
    return row;
  }

  removeBcLine(bcForm: UntypedFormGroup, i): void {
    const bcLineForm = bcForm.get('bcLines') as UntypedFormArray;
    bcLineForm.removeAt(i);
    const removed = this.detailBcLineInfosSource.slice(i, 1);
  }

  purgeDetailBcInfo() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
    this.state.changeSociety(null);
    this.detailBcInfosSource.next(null);
    this.detailBcLineInfosSource.forEach(element => {
      element.complete();
    });
    this.detailBcLineInfosSource = [];
    this.defaultDetailBcLineInfosSource.next(new DetailBcLineinfos());
  }

  getCreateBcFormGroup(): UntypedFormGroup {
    const bc = new BcModel();
    const bcForm = this.getBcForm(bc, BCVALIDATORS.CREATE, BCLINEVALIDATORS.CREATE);
    // Ajout des regles de chargements de données
    this.getBcFormEvent(bcForm);
    return bcForm;
  }

  getRegulariseBcFormGroup(bc: BcModel): UntypedFormGroup {
    const bcForm = this.getBcForm(bc, BCVALIDATORS.REGULARISE, BCLINEVALIDATORS.REGULARISE);
    // Ajout des regles de chargements de données
    this.getBcFormEvent(bcForm);
    return bcForm;
  }

  getBrouillonBcFormGroup(bc: BcModel): UntypedFormGroup {
    const bcForm = this.getBcForm(bc, BCVALIDATORS.BROUILLON, BCLINEVALIDATORS.BROUILLON);
    // Ajout des regles de chargements de données
    this.getBcFormEvent(bcForm);
    return bcForm;
  }

  getBrouillonBcEnveloppeFormGroup(bc: BcModel): UntypedFormGroup {
    const bcForm = this.getBcForm(bc, BCVALIDATORS.BROUILLON, BCLINEVALIDATORS.BROUILLON_ENVELOPPE);
    // Ajout des regles de chargements de données
    this.getBcFormEvent(bcForm);
    return bcForm;
  }

  BROUILLON_ENVELOPPE

  getEditBcFormGroup(bc: BcModel): UntypedFormGroup {
    const bcForm = this.getBcForm(bc, BCVALIDATORS.EDITION, BCLINEVALIDATORS.EDITION);
    return bcForm;
  }

  getEditLinesBCFormGroup(bc: BcModel): UntypedFormGroup {
    const bcForm = this.getBcForm(bc, BCVALIDATORS.VISUALIZE, BCLINEVALIDATORS.EDITION);
    return bcForm;
  }

  getVisualizeBcFormGroup(bc: BcModel): UntypedFormGroup {
    const bcForm = this.getBcForm(bc, BCVALIDATORS.VISUALIZE, BCLINEVALIDATORS.VISUALIZE);
    return bcForm;
  }

  getValidateBcFormGroup(bc: BcModel): UntypedFormGroup {
    const bcForm = this.getBcForm(bc, BCVALIDATORS.VALIDATE, BCLINEVALIDATORS.VALIDATE);
    return bcForm;
  }

  memorizeBc(bc: BcModel): Observable<BcModel> {
    // Ajout des libelle et code sur les lignes pour envoie à l'api
    bc.bcLines.forEach((line) => {
      if (line.libelle === '') { line.libelle = '*'; }
      else if (line.code === '') { line.code = '*'; };
    });
    
    return this.bcService.toBrouillon(bc).pipe(tap(bcUpd => {
      this.toastr.success('BC Memorisé !');
    }));
  }

  livLinesEnv(bc: BcModel, comment: string): Observable<BcModel> {
    const bcwithcomment = new BcValidationModel(bc);
      bcwithcomment.commentaire = comment;
    return this.bcService.updateBCEnv(bcwithcomment).pipe(tap(bcUpd => {
      this.toastr.success('Livraisons BC enveloppe memorisé !');
    }));
  }

  clotureBCE(bc: BcModel, comment: string): Observable<BcModel> {
    const bcwithcomment = new BcValidationModel(bc);
      bcwithcomment.commentaire = comment;
    return this.bcService.clotureBCE(bcwithcomment).pipe(tap(bcUpd => {
      this.toastr.success('BC enveloppe mémorisé et cloturé !');
    }));
  }


  refusBc(bcForRefus: BcValidationModel): Observable<BcModel> {
    return this.bcService.refusBc(bcForRefus).pipe(
      tap(bcUpd => {
        this.toastr.success('BC refusé');
      }));
  }

  validateBc(bcForValidation: BcValidationModel): Observable<BcModel> {
    return this.bcService.validateBc(bcForValidation).pipe(
      tap(bcUpd => {
        this.toastr.success('BC validé');
      }));
  }

  updateBc(bc: BcModel, comment: string): Observable<BcModel> {
    if (bc.id) {
      bc.dModification = new Date(Date.now());
      const bcwithcomment = new BcValidationModel(bc);
      bcwithcomment.commentaire = comment;
      return this.bcService.updateBc(bcwithcomment).pipe(tap(bcUpd => {
      }));
    }
    else {
      this.toastr.error('Erreur lors de la sauvegarde');
    }
  }


  saveBc(bc: BcModel): Observable<BcModel> {
    const dialogConfirmation = this.dialog.open(AddCommentModalComponent, {
      data: {
        title: 'Vous allez envoyer ce bc pour validation',
        message: 'Êtes-vous sûr des informations entrées ?',
        color: 'primary',
        icon_color: 'accent',
      }
    });
    return dialogConfirmation.afterClosed().pipe(switchMap<string, Observable<BcModel>>(res => {
      if (res != null) {
        const bcToValidate = new BcValidationModel(bc);
        bcToValidate.commentaire = res;

        return this.bcService.validateBc(bcToValidate).pipe(tap(bcUpd => {
          if (bcUpd.statusNum == 10) //(Auto)validé
          {
            this.toastr.success('BC auto-validé');
          } else {
            this.toastr.success('BC envoyé pour validation');
          }
        }));
      } else {
        return null;
      }
    }));
  }

  deleteDocument(idBc: number, idDoc: number): Observable<number> {
    const avancement = new BehaviorSubject<number>(0);
    this.subscriptions.push(this.documentService.deleteDocBc(idDoc, idBc).pipe(switchMap(doc => {
      avancement.next(80);
      return this.documentService.delete(idDoc);
    })).subscribe(sub => {
      avancement.next(100);
    }));
    return avancement.asObservable();
  }

  getDocumentById(idBc: number, idDoc: number): Observable<Blob> {
    const avancement = new BehaviorSubject<number>(0);
    return this.documentService.getDocBc(idDoc, idBc);
  }

  sendDocument(filename: string, idBc: number, file: File): Observable<number> {
    const avancement = new BehaviorSubject<number>(0);
    this.subscriptions.push(this.documentService.sendDocBc(filename, idBc, file).pipe(filter((doc: HttpEvent<unknown>) => {
      return doc.type === HttpEventType.Response;
    }),
      switchMap((doc: HttpEvent<unknown>) => {
        avancement.next(80);
        const document = new DocumentModel();
        document.code = filename.substr(0, 30);
        document.libelle = filename;
        document.idBc = idBc;
        return this.documentService.save(document);
      })).subscribe(sub => {
        avancement.next(100);
      }, error => {
        avancement.next(-1);
      }));
    return avancement.asObservable();
  }

  sendImportedBc(file: File): Observable<HttpEvent<string>> {
    return this.bcService.sendImportedBc(file);
  }

  setTodaySDate(): object {
    const todaySDate = new Date();
    const currentMonth = new Date(todaySDate.getFullYear(), todaySDate.getMonth(), todaySDate.getDate(), todaySDate.getHours());
    return currentMonth;
  }

  /**
   * Méthode qui subscribe au bcForm et qui imprime à chaque modification du form les champs invalides
   * en prenant en compte toutes les bcLignes du form.
   * @param form Le bcForm dont on veut vérifier les champs invalides.
   */
  logInvalidControls(form: UntypedFormGroup): void {
    this.subscriptions.push(form.valueChanges.subscribe(_ => {
      const temp = {};
      for (const name in form.controls) {
        if (form.controls[name].invalid) {
          temp[name] = [];
          if (name === 'bcLines') {
            const lignes = form.get('bcLines') as UntypedFormArray;
            const arr = lignes.controls as UntypedFormGroup[];
            arr.forEach((element, index) => {
              temp[name][index] = [];
              for (const control in element.controls) {
                if (element.controls[control].invalid) {
                  temp[name][index].push(control);
                }
              }
            });
          }
        }
      }
    }));
  }

}
